<template>
  <div>
    <b-card no-body>
      <div class="m-2">

        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="8">
            <h4>Danh sách {{options.filter(i => i.value===this.selected)[0].text}}</h4>
          </b-col>
          <b-col class="text-right" cols="4">
            <b-button v-if="options.find(i=>i.value==selected).NewEnabled"
                      class="btn-sm"
                      variant="primary" @click="New()">
              <feather-icon
                  class="align-text-top"
                  icon="PlusIcon"
                  size="16"
              />
              Thêm {{this.options.filter(i => i.value==this.selected)[0].text}}
            </b-button>
          </b-col>
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="fields" :isLoading.sync="isLoading" :line-numbers="true"
                            :pagination-options="{perPage:serverParams.pageSize,enabled: true}"
                            :rows="items"
                            :totalRows="totalRecords"
                            mode="remote"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
            >
              <template
                  slot="table-row"
                  slot-scope="props"
              >

                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                <span>

                     <b-button
                         v-if="options.find(i=>i.value==selected).EditEnabled" class="btn-icon" size="sm" variant="primary"
                         @click="Edit(props.row,props.row.id)">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                      <b-button
                          v-if="options.find(i=>i.value==selected).DeleleEnabled"
                          class="btn-icon"
                          size="sm"
                          style="margin-left:6px"
                          variant="danger"
                          @click="Delete(props.row,props.row.id)">
                        <feather-icon icon="TrashIcon"/>
                      </b-button>
                </span>
              </span>

                <!-- Column: Common -->
                <span
                    v-else-if="allFields.filter(i=>i.field==props.column.field)[0].select2 && allFields.filter(i=>i.field==props.column.field)[0].select2.filter(i => i.id == props.row[props.column.field] ).length>0">
                {{ allFields.filter(i=>i.field==props.column.field)[0].select2.filter(i => i.id == props.row[props.column.field])[0].text }}
              </span>
                <span v-else>
                {{ props.formattedRow[props.column.field]}}
              </span>

              </template>
            </vue-good-table>
          </b-col>

        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="lg" @ok="handleOk">
      <validation-observer ref="modalEdit">
        <b-row>
          <b-col v-for="i in allFields.filter(i => i.field!=='action')" :key="i.field" :md="i.cols != null?i.cols:6"
                 cols="12">
            <validation-provider v-if="i.select2==null" #default="{ errors }"
                                 :name="'\''+i.label+'\''"
                                 :rules="( !i.autoIncrement && (i.field=='name' || i.field=='id' || i.required))?'required':''">
              <b-form-group v-if="i.date_time==true" :label="i.label">
                <b-form-datepicker
                    v-model="currentItem[i.field]"
                    :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }" :state="errors.length > 0 ? false:null"
                    locale="vi-VN"
                />
              </b-form-group>
              <b-form-group v-else-if="i.type=='textarea'" :label="i.label">
                <b-form-textarea v-model="currentItem[i.field]"
                                 :disabled="(i.field==='id' || i.disabled) && editMode || i.autoIncrement || i.hidden" :placeholder="i.autoIncrement?'Hệ thống tự sinh':i.label"
                                 :state="errors.length > 0 ? false:null"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
              <b-form-group v-else :label="i.label">
                <b-form-input v-model="currentItem[i.field]"
                              :disabled="(i.field==='id' || i.disabled) && editMode || i.autoIncrement || i.hidden" :placeholder="i.autoIncrement?'Hệ thống tự sinh':i.label"
                              :state="errors.length > 0 ? false:null"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
            <validation-provider v-else #default="{ errors }"
                                 :name="'\''+i.label+'\''" :rules="(i.field=='name' || i.field=='id' || i.required)?'required':''">
              <b-form-group v-if="i.date_time==true" :label="i.label">
                <b-form-datepicker
                    v-model="currentItem[i.field]"
                    :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }" :state="errors.length > 0 ? false:null"
                    locale="vi-VN"
                />
              </b-form-group>
              <b-form-group v-else :label="i.label">
                <Select2 v-model="currentItem[i.field]" :options="i.select2"
                         :placeholder="i.label" :settings="{multiple:i.multiple?true:false}" :state="errors.length > 0 ? false:null"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

        </b-row>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';


export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormTextarea,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadMasterData();
    var roles = JSON.parse(localStorage.userData).role.split(",");
    if (this.selected == 'B2C_Campaign') {
      if (!roles.includes('MKT')) {
        this.options.find(i => i.value == 'B2C_Campaign').fields = this.options.find(i => i.value == 'B2C_Campaign').fields.filter(f => f.field != 'user');
        this.allFields = this.allFields.filter(i => i.field != 'user');
        this.fields = this.fields.filter(i => i.field != 'user');
      } else {
        this.options.find(i => i.value == 'B2C_Campaign').fields.find(f => f.field == 'user').hidden = false;
      }
      console.log(this.options.find(i => i.value == 'B2C_Campaign'))
    }

  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    }
  },
  methods: {

    loadMasterData() {
      this.selected = this.$route.meta.type;
      this.allFields = this.options.filter(i => i.value == this.selected)[0].fields;
      this.fields = JSON.parse(JSON.stringify(this.options.filter(i => i.value == this.selected)[0].fields));
      this.fields.forEach(i => {
        delete i.select2;
        delete i.cols;
        delete i.autoIncrement;
        delete i.required;
        delete i.multiple;
      })
      this.loadItems();
    },
    getTitle() {
      if (this.editMode) {
        return 'Cập nhật ' + this.options.filter(i => i.value === this.selected)[0].text
      } else {
        return 'Thêm mới ' + this.options.filter(i => i.value === this.selected)[0].text
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams)
      this.loadItems();
    },
    loadItems() {
      useJwt.post('product-master-data/getMasterData/' + this.selected, this.serverParams).then(response => {
        if (response.data.extra != null) {
          for (var key of Object.keys(response.data.extra)) {
            try {
              this.options.filter(i => i.value == this.selected)[0].fields.filter(i => i.field === key)[0].select2 = response.data.extra[key];
            } catch (err) {
            }
          }
        }
        this.items = response.data.result;
        //console.log(this.items);
        this.totalRecords = response.data.totalRecords;
        this.isLoading = false;
      })
    },
    Edit(item, index, button) {
      this.currentItem = item;
      this.editPhoneNote = ''
      this.editMode = true;
      this.modal_title = "Cập nhật " + this.options.filter(i => i.value === this.selected)[0].text
      this.$bvModal.show('modal-edit')
    },
    New() {
      this.currentItem = {}
      this.editMode = false;
      this.modal_title = "Thêm mới " + this.options.filter(i => i.value === this.selected)[0].text
      this.$bvModal.show('modal-edit')
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      console.log(this.currentItem);
      var validate = await this.$refs.modalEdit.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return;
      }
      if (!this.editMode) {
        useJwt.post('product-master-data/masterData/' + this.selected, this.currentItem)
            .then(response => {
              this.loadItems();
              this.$bvModal.hide('modal-edit')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Thêm mới ' + this.options.filter(i => i.value === this.selected)[0].text + ' thành công!',
                  icon: 'CheckSquareIcon',
                  variant: 'primary'
                }
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Lỗi thêm mới ' + this.options.filter(i => i.value === this.selected)[0].text,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger'
                }
              })
            })
      } else {
        var url = 'product-master-data/masterData/' + this.selected;
        useJwt.put(url, this.currentItem)
            .then(response => {
              this.loadItems();
              this.$bvModal.hide('modal-edit')
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Cập nhật ' + this.options.filter(i => i.value === this.selected)[0].text + ' thành công!',
                  icon: 'CheckSquareIcon',
                  variant: 'primary'
                }
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Lỗi cập nhật ' + this.options.filter(i => i.value === this.selected)[0].text + ' [' + error.response.data.result + ']!',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger'
                }
              })
            })
      }
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm('Vui lòng xác nhận bạn muốn xoá dữ liệu ' + this.selected, {
        title: 'Please Confirm',
        size: 'sm',
      })
      if (res) {
        var url = `product-master-data/masterData/${this.selected}/${this.currentItem.id}`;
        useJwt.delete(url, {})
            .then(response => {
              this.loadItems();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Xoá ' + this.options.filter(i => i.value === this.selected)[0].text + ' thành công!',
                  icon: 'CheckSquareIcon',
                  variant: 'primary'
                }
              })
            })
            .catch(error => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Lỗi xoá ' + this.options.filter(i => i.value === this.selected)[0].text,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger'
                }
              })
            })
      }
    },
  },
  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      items: [],
      editMode: false,
      totalItem: 0,
      permisItems: [],
      searchQuery: "",
      searchTerm: '',
      currentItem: {},
      selected: 'product_types',
      editPhoneNote: '',
      options: [
        {
          value: 'product_types',
          text: 'Loại sản phẩm',
          DeleleEnabled: false,
          EditEnabled: true,
          NewEnabled: false,
          fields: [
            {
              field: 'id',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'ID',
              required: true,
            },
            {
              field: 'product_type',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Tên loại sản phẩm',
              required: true,
            },
            {
              field: 'config',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Cấu hình thuộc tính',
              required: true,
              type: 'textarea',
              cols: 12
            },
            {field: 'action', label: 'Actions', width: '90px',}
          ],
        },
        {
          value: 'categories',
          text: 'Quản lý danh mục sản phẩm',
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: 'id',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'ID',
              required: true,
              disabled: true,
            },
            {
              field: 'category_name',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Tên danh mục',
              required: true,
            },
            {
              field: 'parent_id',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Mã cha',
              required: true,
            },
            {
              field: 'group',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Nhóm',
            },
            {
              field: 'slug',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Slug',
              required: true,
            },
            {
              field: 'filter_config',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Cấu hình bộ lọc',
              required: true,
            },
            {
              field: 'status',
              filterOptions: {
                enabled: true, placeholder: '',
                filterDropdownItems: [
                  {value: '1', text: 'Active'},
                  {value: '0', text: 'Deactive'},
                ],
              },
              label: 'Trạng thái',
              required: true,
            },
            {field: 'action', label: 'Actions', width: '90px',}
          ],
        },
        {
          value: 'product_type_discounts',
          text: 'Quản lý giảm giá theo loại sản phẩm',
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: 'id',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'ID',
              required: true,
              disabled: true,
            },
            {
              field: 'product_type_id',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Mã loại sản phẩm',
              required: true,
            },
            {
              field: 'discount_value',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Giá trị giảm',
              required: true,
            },
            {
              field: 'discount_type',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Loại giảm giá',
              required: true,
            },
            {
              field: 'valid_from',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Từ ngày',
              required: true,
              date_time: true
            },
            {
              field: 'valid_to',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Đến ngày',
              required: true,
              date_time: true
            },
            {
              field: 'status',
              filterOptions: {
                enabled: true, placeholder: '',
                filterDropdownItems: [
                  {value: '1', text: 'Active'},
                  {value: '0', text: 'Deactive'},
                ],
              },
              label: 'Trạng thái',
              required: true,
            },
            {field: 'action', label: 'Actions', width: '90px',}
          ],
        },
        {
          value: 'md_units',
          text: 'Danh mục đơn vị tính',
          DeleleEnabled: true,
          EditEnabled: true,
          NewEnabled: true,
          fields: [
            {
              field: 'id',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'ID',
              required: true,
              disabled: true,
            },
            {
              field: 'unit_code',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Tên viết tắt',
              required: true,
            },
            {
              field: 'name',
              filterOptions: {enabled: true, placeholder: ''},
              label: 'Tên đơn vị',
              required: true,
            },
            {field: 'action', label: 'Actions', width: '90px',}
          ],
        },
      ],
      fields: [],
      allFields: [],
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      required
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
